import React, { useState } from 'react';

// Home to sell contingency tasks: text or email the listing agent of the buyer's home.
const isHomeSaleTask = (name) => /^Introduce Yourself to the Listing Agent/i.test(name) || /^Home to Sell Contingency Status Check/i.test(name);

// The listing agent saved on the Under Contract form (home sale section), or null if none.
export const homeSaleAgentOf = (deal) => {
  const uc = deal?.underContract || {};
  const agent = {
    firstName: uc.homeSaleAgentFirstName || '',
    lastName: uc.homeSaleAgentLastName || '',
    phone: uc.homeSaleAgentPhone || '',
    email: uc.homeSaleAgentEmail || '',
  };
  return agent.firstName || agent.lastName || agent.phone || agent.email ? agent : null;
};

export default function HomeSaleAgentQuickContact({ task, agent, contingencyDate, onSent }) {
  const taskName = task?.name || '';
  const [open, setOpen] = useState(false);
  const intro = /^Introduce Yourself/i.test(taskName);
  const first = agent?.firstName || 'there';
  const sign = 'Kelly Olin\nRESIDENCE | eXp Realty\n239-488-5900';
  const defaultText = intro
    ? `Hi ${first}, this is Kelly Olin with RESIDENCE | eXp Realty. We have a buyer under contract whose home sale is contingent on your listing, and I wanted to introduce myself. Call or text me anytime at 239-488-5900.\n\n${sign}`
    : `Hi ${first}, checking in on how things are going with your listing. Our buyer's home sale contingency expires on ${contingencyDate || '[date]'}. Call or text me at 239-488-5900 with any update.\n\n${sign}`;
  const defaultSubject = intro ? 'Introduction: buyer under contract' : 'Checking in on your listing';
  const [text, setText] = useState(defaultText);
  const [subject, setSubject] = useState(defaultSubject);

  if (!isHomeSaleTask(taskName)) return null;

  const name = `${agent?.firstName || ''} ${agent?.lastName || ''}`.trim();
  const digits = (agent?.phone || '').replace(/[^0-9+]/g, '');
  const linkStyle = { display: 'inline-block', padding: '8px 14px', borderRadius: 4, background: '#D4AF37', color: '#000', fontWeight: 600, textDecoration: 'none', fontSize: 13, marginRight: 8 };

  return (
    <div style={{ marginTop: 8, padding: 10, border: '1px solid #E5E0D3', borderRadius: 6, background: '#FFFFFF' }}>
      <div style={{ fontSize: 13, color: '#1A1A1A', fontWeight: 600, marginBottom: 6 }}>
        Listing agent for buyer's home: {name || 'No agent saved'}
      </div>
      {!agent && <div style={{ fontSize: 12, color: '#5B6270', marginBottom: 6 }}>Add the listing agent on the Under Contract form (home sale section).</div>}
      <button type="button" onClick={() => setOpen(o => !o)} style={{ ...linkStyle, border: 'none', cursor: 'pointer' }}>
        {open ? 'Close' : 'Text / email listing agent'}
      </button>
      {open && (
        <div style={{ marginTop: 10 }}>
          <input value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="Email subject" style={{ width: '100%', boxSizing: 'border-box', padding: 8, marginBottom: 8, fontSize: 13 }} />
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={6} style={{ width: '100%', boxSizing: 'border-box', padding: 8, fontSize: 13 }} />
          <div style={{ marginTop: 8 }}>
            {digits && <a href={`sms:${digits}?body=${encodeURIComponent(text)}`} onClick={() => onSent && onSent()} style={linkStyle}>Text</a>}
            {agent?.email && <a href={`mailto:${agent.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(text)}`} onClick={() => onSent && onSent()} style={linkStyle}>Email</a>}
          </div>
        </div>
      )}
    </div>
  );
}
